import React from 'react';
import { Card, Button, Form } from 'react-bootstrap';
import { useState } from 'react'
import '../styles/sidebars.css'
import { supabase } from '../supabaseClient';
import StarRating from './StarRating';

function FoodItem(props) {
    const foodItem = props.foodItem;
    const [editing, setEditing] = useState(false);
    const [myComment, setComment] = useState("");
    const [rating, setRating] = useState();

    function CallBack(value) {
        setRating(value);
    }

    async function addComment(item, rating) {
        try {
            const { data, error } = await supabase
                .from("Comments")
                .insert({
                    food_item: item.id,
                    Name: foodItem.Name,
                    Rating: rating,
                    Comment: myComment,
                })
                .single()
            if (error) throw error;
            window.location.reload();
        } catch (error) {
            alert(error.message);
        }
    }

    async function updateStarRating(item, rating) {
        try {
            const { data, error } = await supabase
                .from("Food Items")
                .update({
                    num_ratings: foodItem.num_ratings + 1,
                    totalStars: foodItem.totalStars + rating,
                    Rating: Math.round((foodItem.totalStars + rating) / (foodItem.num_ratings + 1), 2),
                })
                .eq("id", foodItem.id)

            if (error) throw error;
            window.location.reload();
        } catch (error) {
            alert(error.message);
        }
    }

    console.log(myComment);

    function updateDB(item, rating) {
        addComment(item, rating);
        updateStarRating(item, rating);

    }

    return (
        <div class="px-10 my-2 w-[95vw] max-w-[1000px] transform overflow-hidden rounded-xl bg-white dark:bg-slate-800 shadow-md duration-300 hover:shadow-xl">
            <div class="p-4">
                <h2 class="mb-2 text-lg font-medium dark:text-white text-gray-900">{foodItem.Name}</h2>
                <p class="mb-2 text-base dark:text-gray-300 text-gray-700">{foodItem.Description}</p>
                <p class="mb-2 text-base dark:text-gray-300 text-gray-700">Rating: {foodItem.Rating}/5</p>
                <div class="flex items-center">
                    <button class='mx-auto relative inline-flex text-sm sm:text-base font-medium border-2 border-transparent transition-colors outline-transparent focus:outline-transparent disabled:opacity-50 disabled:pointer-events-none disabled:hover:opacity-40 disabled:cursor-not-allowed disabled:shadow-none
                    text-white bg-[#4040F2] hover:bg-[#3333D1] focus:border-[#B3B3FD] focus:bg-[#4040F2] rounded-lg px-4 w-[1500rem] justify-center'>
                        <div>
                            <Card.Body class="w-[70vw] max-w-[800px]">
                                {editing === false ?
                                    <>
                                        {/* <Card.Title>Comment</Card.Title>
                                    <Card.Text>Make Comment</Card.Text> */}
                                        <Button class="w-[65vw] max-w-[800px]" style={{ width: '100%' }} onClick={() => setEditing(true)}>Add Comment</Button>
                                    </>
                                    :
                                    <>
                                        <p style={{ "display": "inline-block", "padding": "0"}} class="text-lg font-medium dark:text-white text-gray-900">Rate this item:</p>
                                        <div style={{ "margin": "5px" }} />
                                        <StarRating style={{ "display": "inline-block" }} handleCallBack={CallBack} />
                                        {/* <button
                                            onClick={() => (updateDB(foodItem, rating))}
                                            style={{ "display": "inline-block", "margin-left": "40px" }} class='mx-auto relative inline-flex text-sm sm:text-base rounded-full font-medium border-2 border-transparent transition-colors outline-transparent focus:outline-transparent disabled:opacity-50 disabled:pointer-events-none disabled:opacity-40 disabled:hover:opacity-40 disabled:cursor-not-allowed disabled:shadow-none
                    text-white bg-[#4040F2] hover:bg-[#3333D1] focus:border-[#B3B3FD] focus:bg-[#4040F2] px-4 py-1 sm:py-1.5 sm:px-5'>
                                            Submit
                                        </button> */}
                                        <h5>Comment Below</h5>
                                        <div class="form-group">
                                            <textarea class="form-control w-[65vw] max-w-[800px]"
                                                placeholder="Add Comment Here"
                                                // id="exampleFormControlTextarea1" 
                                                // rows="3"
                                                // cols="90"
                                                onChange={(e) => setComment(e.target.value)}
                                            ></textarea>
                                        </div>

                                        <Button onClick={() => setEditing(false)}>Nevermind</Button>
                                        <Button onClick={() => updateDB(foodItem, rating)}>&nbsp;&nbsp;&nbsp; Submit</Button>
                                    </>
                                }
                            </Card.Body>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FoodItem;
